import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import Pagination from '../../model/pagination';
import {environment} from '../../environments/environment';
import QueryEncoder from '../queryEncoder';
import {catchError, switchMap} from 'rxjs/operators';
import CooperationInsightModel from '../../model/cooperationInsight.model';

@Injectable()
export default class CooperationInsightService {
  public constructor(private http: HttpClient) {
  }

  public list(query?: string, page?: number, limit?: number, sort?: string, direction?: string): Observable<Pagination<CooperationInsightModel>> {
    query = query || '';
    page = page || 1;
    limit = limit || 15;
    sort = sort || '';

    let sorting = {};
    sorting[sort] = direction;

    let q = {query, page, limit, sorting};

    return this.http
      .get<Pagination<CooperationInsightModel>>(environment.apiUrl + '/cooperation-insights?' + QueryEncoder.encodeURI(q));
  }

  public show(id: number): Observable<CooperationInsightModel> {
    return this.http.get<CooperationInsightModel>(environment.apiUrl + '/cooperation-insights/' + id);
  }

  public create(insight: CooperationInsightModel): Observable<CooperationInsightModel> {
    return this.http
      .post<CooperationInsightModel>(environment.apiUrl + '/cooperation-insights', insight);
  }

  public update(insight: CooperationInsightModel): Observable<any> {
    return this.http.put(environment.apiUrl + '/cooperation-insights/' + insight.id, insight);
  }

  public delete(insight: CooperationInsightModel): Observable<boolean> {
    return this.http.delete(environment.apiUrl + '/cooperation-insights/' + insight.id).pipe(
      switchMap(result => of(true)),
      catchError(result => of(false))
    );
  }
}
